import { z } from "zod";
import type { infer as zInfer } from "zod";

export const outcomeType = z.enum([
  "FRANCHISE",
  "FRANCHISE_HOME",
  "FRANCHISE_AWAY",

  "PLAYER",
  "PLAYER_HOME",
  "PLAYER_AWAY",

  "YES",
  "NO",
  "ODD",
  "EVEN",
  "DRAW",
  "NO_DRAW",
  "OVER",
  "UNDER",
  "EQUAL",
  "OTHER",

  "CORRECT_SCORE",
  "TOTAL_POINTS",
  "EXACT_GOALS",
  "WINNING_MARGIN",
  "DOUBLE_RESULT",
  "EXACT_SETS",
  "EXACT_GAMES",

  "FIRST_HALF",
  "SECOND_HALF",
  "FIRST_QUARTER",
  "SECOND_QUARTER",
  "THIRD_QUARTER",
  "FORTH_QUARTER",

  "RUNNER_WIN",
  "RUNNER_TOP_2",
  "RUNNER_TOP_3",
  "RUNNER_TOP_4",
  "RUNNER_POS_2",
  "RUNNER_POS_3",
  "RUNNER_POS_4",

  "DRAGON_TYPE",
  "RUNE_TYPE",

  "NONE",
  "UNKNOWN",
]);

export const winCriteria = z.record(
  z.uuid(),
  z.object({
    criteria: z.object({
      LT: z.number().optional(),
      GT: z.number().optional(),
      GTE: z.number().optional(),
      LTE: z.number().optional(),
      EQ: z.number().optional(),
      COMPETITOR_EQ: z.string().optional(),
    }),
    dataType: z.enum(["COMPETITOR_ID", "INTEGER"]),
  }),
);

// per-attribute display data (e.g. "player", "side") - label + sort order
// for whichever attribute a render style groups outcomes by
export const outcomeRenderField = z.object({
  shortAbbreviation: z.string().optional(),
  sortKey: z.number().optional(),
});

export const outcome = z.object({
  abbreviation: z.string().nullish(),
  active: z.boolean().nullish(),
  attributes: z.record(z.string(), z.any()).nullish(),
  closingOdds: z.number().optional(),
  name: z.string().nullish(),
  odds: z.number(),
  openingOdds: z.number().optional(),
  result: z.enum(["VOID", "WIN", "LOSE", "UNDECIDED"]).nullish(),
  type: outcomeType.nullish(),
  competitorId: z.string().optional(),
  // Provider sub-market id, e.g. PLPS_TRY_1 for an NRL first try outcome
  outcomeGroup: z.string().optional(),
  recentOdds: z.array(z.number()).nullish(),
  winCriteria: winCriteria.nullish(),
  renderFields: z.record(z.string(), outcomeRenderField).nullish(),
  // Client-set UI overlay (e.g. pickems highlights the picked/winning outcome);
  // not persisted in Firestore, hence optional.
  highlighted: z.boolean().optional(),
});

export type Outcome = zInfer<typeof outcome>;

export type OutcomeType = zInfer<typeof outcomeType>;
